import { render, staticRenderFns } from "./orgUserList.vue?vue&type=template&id=5ab38ffe&scoped=true&"
import script from "./orgUserList.vue?vue&type=script&lang=tsx&"
export * from "./orgUserList.vue?vue&type=script&lang=tsx&"
import style0 from "./orgUserList.vue?vue&type=style&index=0&id=5ab38ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab38ffe",
  null
  
)

export default component.exports